<template>
  <div class="card p-3 h-100 manage-card shadow-sm">
    <h6 class="pb-3 m-0 font-weight-bold">
      Billing Information
    </h6>
    <table class="" v-if="!showEdit">
      <tr>
        <th class="font-weight-normal py-1 w-50"> Name: </th>
        <td class="py-1">
          {{ bookingDetails.billing_details.name }}
        </td>
      </tr>
      <tr>
        <th class="font-weight-normal py-1"> Email: </th>
        <td class="py-1">
          {{ bookingDetails.billing_details.email }}
        </td>
      </tr>
      <tr>
        <th class="font-weight-normal py-1"> Phone: </th>
        <td class="py-1">
          {{ bookingDetails.billing_details.phone }}
        </td>
      </tr>
      <tr>
        <th class="font-weight-normal py-1"> Nationality/Residency: </th>
        <td class="py-1">
          {{ bookingDetails.billing_details.nicename }}
        </td>
      </tr>
    </table>

    <Transition name="slide-fade">
    <form class="pt-6 pb-2" v-if="showEdit">
      <div class="mb-3">
        <label for="name">
          Name
        </label>
        <input
          class="form-control"
          id="name" type="text" v-model="bookingData.billing_details.name">
      </div>
      <div class="mb-3">
        <label for="email">
          Email
        </label>
        <input
          class="form-control"
          id="email" type="email" v-model="bookingData.billing_details.email">
      </div>
      <div class="mb-3">
        <label for="phone">
          Phone
        </label>
        <input
          class="form-control"
          id="phone" type="phone" v-model="bookingData.billing_details.phone">
      </div>
      <div class="mb-3">
        <label for="nationality">
          Nationality
        </label>
          <select id="nationality" v-model="selected"
            class="form-control"
            @change="updateCountry($event)">
            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.nicename }}</option>
          </select>
      </div>
    </form>
    </Transition>

    <div class="card-footer border-0 p-0 bg-white">
      <p class="text-right mb-0 pt-2" v-if="!showEdit && !cancellationStatus">
        <a href="#" @click.prevent="showEditBillingInfo()">
          Edit Personal Details
        </a>
      </p>
    </div>
    <div class="d-flex justify-items-center justify-content-between pb-2" v-if="showEdit">
      <button
        class="back btn"
        type="button" v-if="showEdit" @click.prevent="showEditBillingInfo()">
        Back
      </button>
      <button
        class="save btn"
        type="button" v-if="showEdit" @click.prevent="editBillingInfo()">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import manageBooking from '../../mixins/manageBooking'
import reusableData from '../../mixins/reusableData'

export default {
  props: {
    cancellationStatus: ''
  },
  data () {
    return {
      showEdit: false,
      success: 0,
      countries: {},
      selected: '',
      bookingData: {}
    }
  },
  methods: {
    dateTime (value) {
      return moment(value).format('ddd, DD MMM YYYY')
    },
    showEditBillingInfo () {
      this.showEdit = !this.showEdit
      this.selected = this.bookingDetails.billing_details.nationality
    },
    updateCountry (event) {
      const countryId = event.target.value
      const nicename = event.target.options[event.target.selectedIndex].text
      this.bookingData.billing_details.nationality = countryId
      this.bookingData.billing_details.nicename = nicename
    },
    updateBookingDataLocal (sortedData) {
      this.bookingData = sortedData
    }
  },
  computed: {
    bookingDetails () {
      const allData = this.$store.getters.bookingDetails
      const fullnames = allData.firstname + ' ' + allData.lastname

      const sortedData = {
        billing_details: {
          'reference': allData.reference_number,
          'name': fullnames,
          'email': allData.email,
          'phone': allData.cellnumber,
          'nationality': allData.nationality,
          'nicename': allData.country
        }
      }

      // update the bookingData object
      this.updateBookingDataLocal(sortedData)
      return sortedData
    }
  },
  beforeMount () {
    // get the countries data
    this.getUrlData()
    this.countries = this.fetchCountries()
  },
  mixins: [manageBooking, reusableData]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/manageBooking/subcomponents/BillingInfo.vue